import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ABTest } from '@freelancer/abtest';
import { Auth } from '@freelancer/auth';
import { Datastore } from '@freelancer/datastore';
import { Feature, FeatureFlagsService } from '@freelancer/feature-flags';
import { ButtonColor } from '@freelancer/ui/button';
import * as Rx from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-navigation-secondary-projects',
  template: `
    <app-bar flTrackingSection="SubnavProjects">
      <app-bar-item
        link="/dashboard/projects.php"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="MyProjects"
        [exactLink]="true"
      >
        My Projects
      </app-bar-item>
      <app-bar-item
        link="/dashboard"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="Dashboard"
        [exactLink]="true"
      >
        Dashboard
      </app-bar-item>
      <app-bar-item
        link="/messages"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="Inbox"
      >
        Inbox
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.DASHBOARD_FEEDBACK_PAGE"
        link="/dashboard/feedback.php"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="Feedback"
        [exactLink]="true"
      >
        Feedback
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.GIVE_GET"
        link="/give"
        i18n="Secondary navigation projects bar item"
        flTrackingLabel="FreeCredit"
        [exactLink]="true"
        [flHideDesktop]="t93229showGiveButtonTestVariation$ | async"
        [flHideTablet]="t93229showGiveButtonTestVariation$ | async"
      >
        Free Credit
      </app-bar-item>
    </app-bar>
  `,
})
export class NavigationSecondaryProjectsComponent implements OnInit {
  Feature = Feature;
  ButtonColor = ButtonColor;

  isGiveGetEligible$: Rx.Observable<boolean> = Rx.of(false);
  userCountry$: Rx.Observable<string>;
  t93229showGiveButtonTestVariation$: Rx.Observable<boolean> = Rx.of(false);

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private auth: Auth,
    private abtest: ABTest,
    private datastore: Datastore,
    private featureFlagService: FeatureFlagsService,
  ) {}

  ngOnInit() {
    this.isGiveGetEligible$ = this.datastore
      .document('referralInvitationCheck', this.auth.getUserId())
      .valueChanges()
      .pipe(map(result => result.isEligible));

    this.userCountry$ = this.datastore
      .document('usersSelf', this.auth.getUserId())
      .valueChanges()
      .pipe(
        map(result =>
          result.address !== undefined && result.address.country !== undefined
            ? result.address.country
            : '',
        ),
      );

    // T93229: AB test for give button on logged in navbar
    // https://www.freelancer.com/admin/abtest/index.php?action=show_experiment&experiment_id=1017
    this.t93229showGiveButtonTestVariation$ = Rx.combineLatest([
      this.isGiveGetEligible$,
      this.userCountry$,
      this.featureFlagService.getFlag(Feature.GIVE_GET),
    ]).pipe(
      switchMap(([isGiveGetEligible, userCountry, featureFlag]) => {
        // Exclude the user from enrollment when whitelist cookie is set
        // while still showing them the test variant.
        if (this.abtest.isWhitelistUser()) {
          return Rx.of(true); // test variant.
        }

        if (
          // Do not enrol user who is outside of US.
          userCountry !== 'United States' ||
          // Do not enrol non-English user into the test.
          !this.locale.startsWith('en') ||
          // Do not enrol enterprise user to the test.
          !featureFlag ||
          // Do not enrol user who is ineligible to the give get program.
          !isGiveGetEligible
        ) {
          return Rx.of(false); // control variant.
        }

        // Enroll the user to the experiment.
        return this.abtest
          .getUserExperimentVariation('T93229-logged-in-navbar-give-button')
          .pipe(map(variation => variation === 'test'));
      }),
    );
  }
}
